import { useState, useEffect, useMemo, useCallback } from 'react';
import { sortByCountryThenName, paginate } from '../AdminTableUtils';
import logger from '../../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useAdminPayments = () => {
  const [transactions, setTransactions] = useState([]);
  const [revenueStats, setRevenueStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('all');
  const [txnPage, setTxnPage] = useState(1);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      const sp = statusFilter !== 'all' ? `?status=${statusFilter}` : '';
      const [txnRes, statsRes] = await Promise.all([
        fetch(`${BACKEND_URL}/api/admin/transactions${sp}`, { headers }),
        fetch(`${BACKEND_URL}/api/admin/revenue-stats`, { headers }),
      ]);
      if (txnRes.ok) { const d = await txnRes.json(); setTransactions(d.transactions || []); }
      if (statsRes.ok) setRevenueStats(await statsRes.json());
    } catch (error) { logger.error('Error fetching payment data:', error); }
    finally { setLoading(false); }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const sorted = useMemo(() => sortByCountryThenName(transactions, 'currency', 'user_name'), [transactions]);
  const paginatedTxns = useMemo(() => paginate(sorted, txnPage), [sorted, txnPage]);
  const sortedCountry = useMemo(() => (
    revenueStats?.revenue_by_country
      ? Object.entries(revenueStats.revenue_by_country).sort((a, b) => b[1].revenue - a[1].revenue)
      : []
  ), [revenueStats]);

  return {
    transactions, revenueStats, loading,
    statusFilter, setStatusFilter,
    txnPage, setTxnPage,
    sorted, paginatedTxns, sortedCountry,
    fetchData,
  };
};
